"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTagInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsTagInput Component.
 *
 * @component
 *
 * @param {Object} props - Component properties.
 * @param {string} props.title - Title of the tag input.
 * @param {Function} props.onSaveTags - Function called when tags are saved.
 * @param {string} props.placeholder - Placeholder text for tag input.
 * @param {Function} props.tagFilter - Filter function for tag entries.
 *
 * @returns {JSX.Element} - JSX element of the component.
 */
const DmsTagInput = _ref => {
  let {
    title,
    onSaveTags,
    placeholder,
    tagFilter
  } = _ref;
  const [tags, setTags] = (0, _react.useState)([]);
  const [tagInput, setTagInput] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    onSaveTags(tags);
  }, [tags, onSaveTags]);

  /**
   * Add a tag to the list.
   */
  const addTag = () => {
    const filteredTag = tagFilter ? tagFilter(tagInput) : tagInput.trim();
    if (filteredTag) {
      setTags([...tags, filteredTag]);
      setTagInput('');
    }
  };

  /**
   * Remove a tag from the list.
   * @param {number} index - Index of the tag to be removed.
   */
  const removeTag = index => {
    const newTags = [...tags];
    newTags.splice(index, 1);
    setTags(newTags);
  };
  return /*#__PURE__*/_react.default.createElement(_material.Container, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, title && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle1"
  }, title), /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    title: _reactIntlUniversal.default.get('taginputtooltip').d('Press Space or Enter to add the tag')
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    variant: "outlined",
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "Add a tag",
    value: tagInput,
    onChange: e => setTagInput(e.target.value),
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        addTag();
      }
    }
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginTop: '10px'
    }
  }, tags.map((tag, index) => /*#__PURE__*/_react.default.createElement(_material.Chip, {
    key: index,
    label: tag,
    onDelete: () => removeTag(index),
    style: {
      margin: '4px'
    }
  }))))));
};
exports.DmsTagInput = DmsTagInput;
DmsTagInput.propTypes = {
  onSaveTags: _propTypes.default.func.isRequired,
  title: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  tagFilter: _propTypes.default.func
};